import type { VehicleFetchInfo } from '../types.graphql'

/**
 * `integrationEndpoint` is the GraphQL enum name generated from
 * `VehicleFetchInfo.INTEGRATION_ENDPOINT_CHOICES` in the backend, e.g.
 * `DEVINCO_POSITIONS` or `A_3DTRACKING` (graphene prefixes values that start
 * with a digit). Keys here are normalized with `normalizeEndpoint`, so raw
 * database values (`"devinco positions"`, `"3dtracking"`) map to the same
 * label. Keep in sync with the backend choices.
 */
const ENDPOINT_LABELS: Record<string, string> = {
  VOLVO_STATUSES: 'Volvo',
  SCANIA_RFMS: 'Scania',
  SCANIA_TRACKING_HISTORY: 'Scania',
  FLEETBOARD_GETPOSREPORT: 'FleetBoard',
  MAN_IOT_EVENTS: 'MAN',
  DEVINCO_POSITIONS: 'Devinco',
  '3DTRACKING': '3D Tracking',
  BRE_DIGITAL: 'BRE Digital',
  TRACKSYS: 'Tracksys',
  THERMOKING: 'Thermoking',
}

const normalizeEndpoint = (endpoint: string) =>
  endpoint.trim().toUpperCase().replace(/\s+/g, '_').replace(/^A_/, '')

export function getDisplayStringFromVehicleFetchInfoEndpoint(
  vehicleFetchInfo: VehicleFetchInfo
): string {
  const endpoint = normalizeEndpoint(vehicleFetchInfo.integrationEndpoint)

  if (ENDPOINT_LABELS[endpoint]) return ENDPOINT_LABELS[endpoint]
  if (!endpoint) return '-'

  // Unknown endpoint (a new backend integration this build doesn't know about):
  // show a readable form of it rather than mislabelling it as another provider.
  const words = endpoint.replace(/_/g, ' ').toLowerCase()
  return words.charAt(0).toUpperCase() + words.slice(1)
}
